<template>
  <div class="flex-row align-center margin-top-24">
    <div class="flex-column">
      <div class="sac__font-14">
        Send invoice to
      </div>
      <div class="flex-row">
        <SACInput
          :value="email"
          :change="(f, v) => email = v"
          placeholder="Enter email"
        />
        <button
          type="button"
          class="sac__button bg-primary margin-left-8"
          :disabled="disableAdd"
          @click="createChargebeeContact"
        >
          Add <span class="icon-luc-Plus sac__font-16" />
        </button>
      </div>
    </div>
    <div
      v-for="contact in chargebeeContacts"
      :key="contact.id"
      class="contact-pill flex-row align-center margin-left-8"
    >
      {{ contact.email }}
      <button
        type="button"
        class="flex-row align-center justify-center"
        @click="deleteChargebeeContact(contact.id)"
      >
        <i class="icon-Trash sac__font-18 tomato margin-left-4" />
      </button>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

import emailValidation from '@shared/lib/errorCatch/emailValidation';

import SACInput from '@shared/components/sac/SACInput.vue';

export default {
  name: 'InvoiceInput',
  components: {
    SACInput,
  },
  props: {
    branch: Object,
  },
  data() {
    return {
      email: '',
    };
  },
  computed: {
    ...mapState({
      chargebeeCustomers: (state) => state.partnerAgreement.chargebeeCustomers,
    }),
    disableAdd() {
      let disable = false;
      if (!this.email) {
        disable = true;
      } else if (!emailValidation(this.email)) {
        disable = true;
      }
      return disable;
    },
    chargebeeContacts() {
      return this.chargebeeCustomers[this.branch.id]?.contacts || [];
    },
  },
  methods: {
    async createChargebeeContact() {
      await this.$store.dispatch('createAgreementChargebeeContact', {
        corpId: this.branch.id,
        invoiceEmail: this.email,
      });
      this.email = '';
    },
    deleteChargebeeContact(contactId) {
      this.$store.dispatch('deleteAgreementChargebeeContact', {
        corpId: this.branch.id,
        contactId,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
#sac-input-container {
  width: 300px;
}

.contact-pill {
  padding: 4px 8px;
  background-color: #f5f5f5;
  border-radius: 8px;
}
</style>
